import EmployeeSelector from './employeeSelector';

export default EmployeeSelector;
